import React from 'react';
import App from 'codeArt/external/containers/App';
import {Route, Switch, withRouter} from 'react-router-dom';
import asyncComponent from '../util/asyncComponent';
import { MenuRoot,MenuGroup,Menu, MenuItem } from 'codeArt/auth';
import { Events, DomainConfig } from 'js/context';
import { RequestConfig, Principal, Notification } from 'codeArt/common';
import Backdrop from 'codeArt/components/Backdrop';
import { Explorer } from 'codeArt/components/Explorer';

export default class Index extends React.Component {

  constructor(props) {
    super(props);
  }

  init(cb){
    RequestConfig.domain = DomainConfig.request.personal;
    // RequestConfig.uploadUrl = DomainConfig.file + "/upload.htm";

    cb();
  }

  render(){
    let {match}=this.props;
    return (
      <App name="extra" layout={"slim"} init={this.init.bind(this)}>
        <Switch>
          <Route path={'/init'} component={asyncComponent(() => import('./login/Init'))} />
          <Route path={'/signin'} component={asyncComponent(() => import('./login/SignIn'))} />
          <Route path={'/signinByCode'} component={asyncComponent(() => import('./login/SignInByCode'))} />
          <Route path={'/forgeter'} component={asyncComponent(() => import('./login/Forgeter'))} />
          <Route path={'/completeForgeter/:params'} component={asyncComponent(() => import('./login/CompleteForgeter'))} />
          <Route path={'/register'} component={asyncComponent(() => import('./login/Register'))} />
          <Route path={'/completeRegister/:params'} component={asyncComponent(() => import('./login/CompleteRegister'))} />
          <Route path={'/signup'} component={asyncComponent(() => import('./login/SignUp'))} />
          <Route path={'/interview/write/:params'} component={asyncComponent(() => import('./interview/write'))} />
          <Route path={'/interview/preview'} component={asyncComponent(() => import('./interview/preview'))} />
          <Route
            component={asyncComponent(() => import('./tools/routes/404/index'))} />
        </Switch>
      </App>
    )
  }
}